import { useEffect } from 'react';
import { getUser } from '@frontend/auth-helpers';
import { shell } from '@frontend/shell-utils';
import { pendo } from '@frontend/tracking';

type UseLegacyOnboardingCompactModeParams = {
  appState: string;
  showOnboardingFlow?: boolean;
  existingUser?: boolean;
  isLegacyUser?: boolean;
  setExistingUser: (value: boolean) => void;
  setShowExpandModeNudge: (value: boolean) => void;
};

export const useLegacyOnboardingCompactMode = ({
  appState,
  showOnboardingFlow,
  existingUser,
  isLegacyUser,
  setExistingUser,
  setShowExpandModeNudge,
}: UseLegacyOnboardingCompactModeParams) => {
  const userID = getUser()?.userID || '';

  useEffect(() => {
    if (!showOnboardingFlow || existingUser || !isLegacyUser || appState !== 'LOCATION_SELECTION') {
      return;
    }
    pendo.track('compact_mode_onboarding_flow_seen', {
      userId: userID,
      timestamp: new Date().toISOString(),
    });

    shell?.invoke?.('main:update-options', { width: 400 });

    setExistingUser(true);
    setShowExpandModeNudge(true);
  }, [appState, showOnboardingFlow, existingUser, isLegacyUser, setExistingUser, setShowExpandModeNudge]);
};
